export enum ButtonRedirectTarget {
  Page = 'page',
  OpenInNewTab = '_blank'
}
